import { LEFT_PAGE, RIGHT_PAGE } from "../constants";

const findPageToJump = (page, currentPage, neighbours) => {
  if (page === LEFT_PAGE) return currentPage - neighbours * 2 - 1;
  else if (page === RIGHT_PAGE) return currentPage + neighbours * 2 + 1;
  else return page;
};

export default findPageToJump;
